import React from 'react'

interface ImagePreviewViewerProps {
  imageUrl: string
  title: string
  previewText?: string
}

export const ImagePreviewViewer: React.FC<ImagePreviewViewerProps> = ({
  imageUrl,
  title,
  previewText
}) => (
  <div className="flex h-full flex-col overflow-auto p-1">
    <div className="flex flex-1 items-center justify-center">
      <img src={imageUrl} alt={title} className="max-w-full max-h-full" />
    </div>
    {previewText && (
      <p className="theme-citation-highlight-content m-0 px-50 py-25 text-body-small">
        {previewText}
      </p>
    )}
  </div>
)
